const homeMenuItem = {
  icon: 'Home',
  key: 'dashboard',
  title: 'DASHBOARD',
  url: '/',
};
const auctionsMenuItem = {
  icon: 'Hummer2',
  key: 'auctions',
  title: 'AUCTIONS',
};
const partiesMenuItem = {
  icon: 'Group',
  key: 'parties',
  title: 'PARTIES',
};
const gtEstimateMenuItem = {
  icon: 'Outlet',
  key: 'gtestimate',
  title: 'GT Estimate',
  url: '/gtestimate',
};
const feesMenuItem = {
  icon: 'Clipboard-list',
  key: 'fees',
  title: 'FEES',
  url: '/fees',
};
const infoMenuItem = {
  icon: 'Info-circle',
  key: 'info',
  title: 'VDFM_INFO',
  url: 'modal_Info',
};

const menuItemsOperator = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'pending-approval-auctions',
        title: 'PENDING_APPROVAL',
        url: '/auctions/pending-approval',
      },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      {
        key: 'no-offer-auctions',
        title: 'NO_OFFER',
        url: '/auctions/no-offer',
      },
    ],
  },
  {
    ...partiesMenuItem,
    subItems: [
      { key: 'all-parties', title: 'LIST', url: '/all-parties' },
      { key: 'new-party', title: 'CREATE_NEW', url: '/parties/new' },
    ],
  },
  gtEstimateMenuItem,
  feesMenuItem,
  //  { key: 'settings', title: 'SETTINGS', iconClassName: 'icon-settings', url: '/settings' },
];

const menuItemsAdminInsurance = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'pending-approval-auctions',
        title: 'PENDING_APPROVAL',
        url: '/auctions/pending-approval',
      },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      {
        key: 'no-offer-auctions',
        title: 'NO_OFFER',
        url: '/auctions/no-offer',
      },
      {
        key: 'create-new-auction',
        title: 'CREATE_NEW_FEM',
        url: '/auctions/createnew',
      },
    ],
  },
  {
    ...partiesMenuItem,
    subItems: [
      { key: 'all-parties', title: 'LIST', url: '/all-parties' },
      { key: 'new-party', title: 'CREATE_NEW', url: '/parties/new' },
    ],
  },
  gtEstimateMenuItem,
  //  { key: 'settings', title: 'SETTINGS', iconClassName: 'icon-settings', url: '/settings' },
];

const menuItemsInsurance = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'pending-approval-auctions',
        title: 'PENDING_APPROVAL',
        url: '/auctions/pending-approval',
      },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      {
        key: 'rejected-auctions',
        title: 'REJECTED_PL_FEM',
        url: '/auctions/rejected',
      },
      {
        key: 'create-new-auction',
        title: 'CREATE_NEW_FEM',
        url: '/auctions/createnew',
      },
    ],
  },
];

const menuItemsMerchant = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      { key: 'auctions-new', title: 'NEW_FEMALE_PL', url: '/auctions/new' },
      {
        key: 'participate-to',
        title: 'PARTICIPATE_TO',
        url: '/auctions/participate-to',
      },
      // {
      //   key: 'merchant-summary',
      //   title: 'OFFER_STATUS',
      //   url: '/auctions/merchant-summary',
      // },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      { key: 'lost-auctions', title: 'FINISHED', url: '/auctions/lost' },
    ],
  },
  feesMenuItem,
  infoMenuItem,
];

export {
  menuItemsInsurance,
  menuItemsMerchant,
  menuItemsOperator,
  menuItemsAdminInsurance,
};
